

import React, { memo, useCallback, useEffect, useState } from 'react';
import _isEmpty from 'lodash.isempty';
import Button from '../../Button'; // Import ButtonFactory component
import Icon from '../../Icon';
import { FLATTENED_COLOURS } from '../../../common/styles/vars';

import '../styles/_chiplist.scss';



























const ChipItemComponent = ({
  item,
  isDisabled,
  iconSize,
  handleItemClick,
  prefix,
  prefixAfterSelect = prefix,
  suffix,
  suffixAfterSelect = suffix,
  borderColorOnSelect,
  bgColorOnSelect
}) => {
  const { label, disabled, selected } = item;

  const getBorderColor = (itemSelected, itemDisabled) => {
    if (itemSelected && itemDisabled) return 'transparent';
    if (itemSelected) return FLATTENED_COLOURS[borderColorOnSelect];
    return '#D4D9E2';
  };

  const getBackground = (itemSelected, itemDisabled) => {
    if (itemSelected && itemDisabled) return '#f4f6fa';
    if (isDisabled) return 'transparent';
    if (itemSelected) return FLATTENED_COLOURS[bgColorOnSelect];
    return '#FFF';
  };

  const getTextColor = (itemSelected, itemDisabled) => {
    if (itemSelected && itemDisabled) return '#696D74';
    if (itemSelected) return FLATTENED_COLOURS[borderColorOnSelect];
    return '#8C96A9';
  };

  const chipItemStyles = {
    borderColor: getBorderColor(selected, isDisabled),
    background: getBackground(selected, isDisabled),
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    pointerEvents: isDisabled ? 'none' : 'auto'
  };

  const getIconProps = (iconName, isSelected) => ({
    name: iconName || '',
    size: iconSize,
    color: isSelected ? borderColorOnSelect : 'nevada'
  });

  return (
    <Button
      disabled={disabled}
      key={label}
      type="TERTIARY"
      className="chipitem"
      style={chipItemStyles}
      onClick={() => handleItemClick(item)}
      selected={selected}
      bgColorOnSelect={bgColorOnSelect}
      borderColorOnSelect={borderColorOnSelect}
      prefix={
      <Icon
        {...getIconProps(selected ? prefixAfterSelect : prefix, selected)} />}


      suffix={
      <Icon
        {...getIconProps(selected ? suffixAfterSelect : suffix, selected)} />}


      fromChipList>

      <span
        className="button--text"
        style={{ color: getTextColor(selected, isDisabled) }}>

        {label}
      </span>
    </Button>);

};

function Chiplist(props) {
  const {
    isDisabled,
    borderColorOnSelect,
    bgColorOnSelect,
    iconSize = 12,
    value,
    data,
    onSelectItems,
    isMultiSelect,
    prefix,
    suffix,
    prefixAfterSelect,
    suffixAfterSelect
  } = props;

  const [chipListState, setChipListState] = useState(data);

  const toggleItemSelection = (item) => chipListState.map((chip) =>
  chip === item ? { ...chip, selected: !chip.selected } : chip
  );

  const selectSingleItem = (item) => chipListState.map((chip) => ({
    ...chip,
    selected: chip === item
  }));

  const handleItemClick = useCallback(
    (item) => {
      const updatedItems = isMultiSelect ?
      toggleItemSelection(item) :
      selectSingleItem(item);

      setChipListState(updatedItems);
      onSelectItems(item.label);
    },
    [isMultiSelect, onSelectItems]
  );

  useEffect(() => {
    if (!_isEmpty(value)) {
      const initialData = chipListState.map((item) => ({
        ...item,
        selected: value.includes(item.label)
      }));
      setChipListState(initialData);
    }
  }, []);

  return (
    <div className="chiplist-wrapper">
      {chipListState.map((item) =>
      <ChipItemComponent
        key={item.label}
        isDisabled={isDisabled}
        item={item}
        iconSize={iconSize}
        handleItemClick={handleItemClick}
        prefixAfterSelect={item.prefixAfterSelect || prefixAfterSelect}
        prefix={item.prefix || prefix}
        suffixAfterSelect={item.suffixAfterSelect || suffixAfterSelect}
        suffix={item.suffix || suffix}
        borderColorOnSelect={borderColorOnSelect}
        bgColorOnSelect={bgColorOnSelect} />

      )}
    </div>);

}

ChipItemComponent.defaultProps = {
  bgColorOnSelect: 'monkey25',
  borderColorOnSelect: 'monkey'
};

export default memo(Chiplist);